module.exports = __webpack_public_path__ + "static/media/phone6.f9b20c07.png";